import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import '@styles/pages/app.scss';
import './../node_modules/antd/dist/antd.css';
import {StageDefault} from '@/context.ts';
import {fetch} from '@/fetch.ts';
import Tab1 from '@hook/Tab1/index.tsx';
import Tab2 from '@hook/Tab2/index.tsx';
import Tab3 from '@hook/Tab3/index.tsx';
import Tab4 from '@hook/Tab4/index.tsx';
import Toast from '@hook/public/toast.tsx';
const { useState, useEffect } = React;

interface StyleType {
  width: string,
  height: string,
}
interface TabType {
  tabName: string,
  tabCurrent: number,
  openImg: any,
  closeImg: any,
}
const Images = Object.keys({
  tab1s: 'tab1s',
  tab1: 'tab1',
  tab2s: 'tab2s',
  tab2: 'tab2',
  tab3s: 'tab3s',
  tab3: 'tab3',
  tab4s: 'tab4s',
  tab4: 'tab4',
  header: 'header',
  footer: 'footer',
}).map((item: any) => require(`./assets/images/${item}.png`));
const images = [];
for (let i = 0; i < Images.length; i++) {
  images[i] = new Image();
  images[i].src = Images[i].default;
}
const tabs: TabType[] = [
  {
    tabName: '成团资格赛',
    tabCurrent: 1,
    openImg: Images[0].default,
    closeImg: Images[1].default,
  },
  {
    tabName: '分区冠军赛',
    tabCurrent: 2,
    openImg: Images[2].default,
    closeImg: Images[3].default,
  },
  {
    tabName: '神豪榜',
    tabCurrent: 3,
    openImg: Images[4].default,
    closeImg: Images[5].default,
  },
  {
    tabName: '规则',
    tabCurrent: 0,
    openImg: Images[6].default,
    closeImg: Images[7].default,
  },
];

const App: React.FC = () => {

  /* 计算 header 与 footer 大小 */
  const styleCompute: (size: number) => StyleType = size => {
    let styleOutput: StyleType;
    styleOutput = {
      width: `${document.body.offsetWidth > 1300 ? document.body.offsetWidth - 10 : 1300}px`,
      height: `${((document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300) * size) / 1920}px`,
    }
    return styleOutput;
  }
  const [headStyle, HeadStyle] = useState<StyleType>(styleCompute(960));
  const [footStyle, FootStyle] = useState<StyleType>(styleCompute(580));
  useEffect(() => {
    window.onresize = (): void => {
      HeadStyle(styleCompute(1000));
      FootStyle(styleCompute(580));
    }
  }, [])

  /* tab状态 */
  const [tabList] = useState<TabType[]>(tabs);
  const [tabCurrent, TabCurrent] = useState<number>(0);
  const [tabNow, TabNow] = useState<number>(0);
  const [iStage, IStage] = useState<number>(0);
  /* toast开关 */
  const [showTabToast, ShowTabToast] = useState<string>('');
  const tabToastOpen: (text: string) => void = text => {
    ShowTabToast(text);
    setTimeout(() => {
      ShowTabToast('');
    }, 3000)
  }
  useEffect(() => {
    // console.log = () => null;
    /* 获取赛程 */
    fetch.getStageInfo(
      {
        lPid: 0,
        iMatchId: 0,
      },
    )
      .then(rsp => {
        if (rsp.iMatchId === 1 && rsp.iStage === 0) {
          IStage(0);
          TabCurrent(0);
          TabNow(0);
          return;
        } else if (rsp.iMatchId === 2 && rsp.iStage === 0) {
          IStage(1);
          TabCurrent(1);
          TabNow(1);
          return;
        }
        IStage(rsp.iStage > 4 ? 4 : rsp.iStage);
        TabCurrent(rsp.iMatchId);
        TabNow(rsp.iMatchId);
      })
  }, [])

  return (
    <div className="App">
      { showTabToast !== '' && <Toast text={showTabToast} />}
      <section className='app_bg'>
        <video
          className={'head_cover'}
          src='https://diy-assets.msstatic.com/hyys/dongtai_toutu/2020 Fengshij V013-1.mp4'
          autoPlay={true}
          muted={true}
          loop={true}
          style={headStyle}
          poster={Images[8].default}
        />
        <div className='app_content'>
          <ul className='tabs'>
            {
              tabList.map((item: TabType) => (
                <li
                  key={item.tabName}
                  style={{
                    backgroundImage: `url(${tabCurrent === item.tabCurrent ? item.openImg  : item.closeImg})`,
                    cursor: `${tabCurrent === item.tabCurrent ? 'default'  : 'pointer'}`,
                  }}
                  onClick={
                    (): void => {
                      if (tabNow === 1 && item.tabCurrent === 2) {
                        tabToastOpen('该活动尚未开启~');
                        return;
                      }
                      if (tabNow === 0) {
                        tabToastOpen('该活动尚未开启~');
                        return;
                      }
                      TabCurrent(item.tabCurrent);
                    }
                  }
                ></li>
              ))
            }
          </ul>
          <StageDefault.Provider
            value={{iStage, tabCurrent, tabToastOpen}}
          >
            {
              [Tab4, Tab1, Tab2, Tab3].map((item: any, index: number): any => {
                if (index === tabCurrent) {
                  const COMP = item;
                  return <COMP key={index}/>
                }
              })
            }
          </StageDefault.Provider>
        </div>
        <img
          className='foot_cover'
          alt='底部背景'
          src={Images[9].default}
          style={footStyle}
        />
      </section>
    </div>
  );
}
 
export default hot(App);